import { CHANGE_LOCATION_FILTER, CLEAR_MULTI_FILTER, CHANGE_MODAL_MULTI_FILTER, CHANGE_MODAL_PROPERTY_TYPE, TOGGLE_FILTER, CHANGE_SORTING, CHANGE_POPULAR_CITY, CHANGE_PAGE, SELECT_SEARCHED_RESULT, CHANGE_SEARCH_CONTENT, CHANGE_SPECIAL_FEATURE, CLEAR_SEARCH_CONTENT, CHANGE_PROPERTY_TYPE, CHANGE_PROPERTY_SUB_TYPE, CHANGE_TO_ANY, CLEAR_ALL, RESET_PAGE_NO, FOOTER_LOC } from "./filterConstants";

const initialState = {
    searchbar: '',
    modalFilter: {
        pricemin: null,
        pricemax: null,
        number_of_beds: null,
        number_of_baths: null,
        squarefeetmin: null,
        squarefeetmax: null,
        highschooldistrict: null,
        highschool: null,
        subdivisionname: null,
        zip: null,
        city: null,
        countyOrParish: null,
        lotFeatures: null,
        newconstructionyn: null,
        garagespacesmin: null,
        garagespacesmax: null,
        yearbuiltmin: null,
        yearbuiltmax: null,
        fireplacemin: null,
        fireplacemax: null,
        daysonMarket: null,
    },
    propertytype: [],
    propertysubtype: [],
    specialFeature: {
        luxury: null,
        golf_Course: null,
        horse_Permitted: null,
        pool_Access: null,
        waterfront: null,
        riverfront: null,
        lakefront: null,
        pool_In_Ground: null,
        pool_Above_Ground: null,
        out_Building: null
    },
    sorting: {
        new_listing: true,
        lowest_price: null,
        highest_price: null,
        year_built: null,
        open_house_date: null,
        recently_reduced: null,
        largest_sqft: null,
        lot_size: null
    },
    isSortType: "new_listing",
    locationParams: {
        city: null,
        country: 'US',
        countyOrParish: null,
        zip: null,
        stateOrProvince: null
    },
    isSearched: false,
    pageNo: 1,
    pageSize: 20,
    toggleFilter: false,
    clearFilter: false,
    footerFilter: {
        filterKey: '',
        filterValue: ''
    }
}

const filterReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        // case CHANGE_LOCATION_FILTER:
        //     return { ...state, searchbar: payload, modalFilter: { ...state?.modalFilter, pageNo: 1 } }

        // case CHANGE_POPULAR_CITY:
        //     return { ...state, modalFilter: { ...state.modalFilter, ...payload, pageNo: 1, }, searchbar: `${payload?.city},${payload?.stateOrProvince}` }

        case CHANGE_MODAL_MULTI_FILTER:
            return { ...state, modalFilter: { ...state.modalFilter, ...payload } }

        case TOGGLE_FILTER:
            return { ...state, toggleFilter: !state?.toggleFilter }

        // case CHANGE_MODAL_PROPERTY_TYPE:
        //     let defaultPara = {
        //         propertytype: null,
        //         propertysubtype: null,
        //         luxury: null,
        //         golf_Course: null,
        //         horse_Permitted: null,
        //         pool_Access: null,
        //         waterfront: null,
        //         riverfront: null,
        //         lakefront: null,
        //         pool_In_Ground: null,
        //         pool_Above_Ground: null,
        //         out_Building: null
        //     }

        //     defaultPara[payload?.proValue?.k] = payload?.proValue?.v

        //     return { ...state, defaultPropertyType: { ...state.defaultPropertyType, ...defaultPara }, isPropertyType: payload?.activePropertyType, modalFilter: { ...state?.modalFilter, pageNo: 1 } }

        case CHANGE_SORTING:
            let defaultSorting = {
                new_listing: null,
                lowest_price: null,
                highest_price: null,
                year_built: null,
                open_house_date: null,
                recently_reduced: null,
                largest_sqft: null,
                lot_size: null
            }
            defaultSorting[payload?.sortKey] = payload?.sortValue

            return { ...state, sorting: defaultSorting, isSortType: payload?.sortKey }

        case CHANGE_PAGE:
            return { ...state, pageNo: payload === "inc" ? state?.pageNo + 1 : state?.pageNo - 1, toggleFilter: !state?.toggleFilter }

        case RESET_PAGE_NO:
            return { ...state, pageNo: 1 }

        // case CLEAR_MULTI_FILTER:
        //     return {
        //         ...state,
        //         searchbar: '',
        //         modalFilter: {
        //             pricemin: null,
        //             pricemax: null,
        //             number_of_beds: null,
        //             number_of_baths: null,
        //             squarefeetmin: null,
        //             squarefeetmax: null,
        //             highschooldistrict: null,
        //             highschool: null,
        //             subdivisionname: null,
        //             zip: null,
        //             city: null,
        //             country: "US",
        //             countyOrParish: null,
        //             lotFeatures: null,
        //             newconstructionyn: null,
        //             garagespacesmin: null,
        //             garagespacesmax: null,
        //             yearbuiltmin: null,
        //             yearbuiltmax: null,
        //             fireplacemin: null,
        //             fireplacemax: null,
        //             daysonMarket: null,
        //             pageNo: 1,
        //             pageSize: 20,
        //         },
        //         defaultPropertyType: {
        //             propertytype: null,
        //             propertysubtype: null,
        //             luxury: null,
        //             golf_Course: null,
        //             horse_Permitted: null,
        //             pool_Access: null,
        //             waterfront: null,
        //             riverfront: null,
        //             lakefront: null,
        //             pool_In_Ground: null,
        //             pool_Above_Ground: null,
        //             out_Building: null
        //         },
        //         isPropertyType: null,
        //         sorting: {
        //             new_listing: true,
        //             lowest_price: null,
        //             highest_price: null,
        //             year_built: null,
        //             open_house_date: null,
        //             recently_reduced: null,
        //             largest_sqft: null,
        //             lot_size: null
        //         },
        //         isSortType: "new_listing"
        //     }

        case CHANGE_TO_ANY:
            return {
                ...state, propertytype: [], propertysubtype: [], specialFeature: {
                    luxury: null,
                    golf_Course: null,
                    horse_Permitted: null,
                    pool_Access: null,
                    waterfront: null,
                    riverfront: null,
                    lakefront: null,
                    pool_In_Ground: null,
                    pool_Above_Ground: null,
                    out_Building: null
                }
            }

        case CHANGE_PROPERTY_TYPE:
            return { ...state, propertytype: state?.propertytype.includes(payload) ? state?.propertytype.filter(pt => pt != payload) : [...state?.propertytype, payload] }

        case CHANGE_PROPERTY_SUB_TYPE:
            return { ...state, propertysubtype: state?.propertysubtype.includes(payload) ? state?.propertysubtype.filter(pt => pt != payload) : [...state?.propertysubtype, payload] }

        case SELECT_SEARCHED_RESULT:
            return { ...state, locationParams: payload, isSearched: true, toggleFilter: !state.toggleFilter }

        case CHANGE_SEARCH_CONTENT:
            return { ...state, searchbar: payload }

        case CHANGE_SPECIAL_FEATURE:
            return { ...state, specialFeature: { ...state.specialFeature, ...payload } }

        case CLEAR_SEARCH_CONTENT:
            return {
                ...state, locationParams: {
                    city: null,
                    country: 'US',
                    countyOrParish: null,
                    zip: null,
                    stateOrProvince: null
                }
            }

        case CLEAR_ALL:
            return {
                ...state,
                searchbar: '',
                modalFilter: {
                    pricemin: null,
                    pricemax: null,
                    number_of_beds: null,
                    number_of_baths: null,
                    squarefeetmin: null,
                    squarefeetmax: null,
                    highschooldistrict: null,
                    highschool: null,
                    subdivisionname: null,
                    zip: null,
                    city: null,
                    countyOrParish: null,
                    lotFeatures: null,
                    newconstructionyn: null,
                    garagespacesmin: null,
                    garagespacesmax: null,
                    yearbuiltmin: null,
                    yearbuiltmax: null,
                    fireplacemin: null,
                    fireplacemax: null,
                    daysonMarket: null,
                },
                propertytype: [],
                propertysubtype: [],
                specialFeature: {
                    luxury: null,
                    golf_Course: null,
                    horse_Permitted: null,
                    pool_Access: null,
                    waterfront: null,
                    riverfront: null,
                    lakefront: null,
                    pool_In_Ground: null,
                    pool_Above_Ground: null,
                    out_Building: null
                },
                sorting: {
                    new_listing: true,
                    lowest_price: null,
                    highest_price: null,
                    year_built: null,
                    open_house_date: null,
                    recently_reduced: null,
                    largest_sqft: null,
                    lot_size: null
                },
                isSortType: "new_listing",
                locationParams: {
                    city: null,
                    country: 'US',
                    countyOrParish: null,
                    zip: null,
                    stateOrProvince: null
                },
                isSearched: false,
                pageNo: 1,
                pageSize: 20,
                toggleFilter: false,
                clearFilter: !state.clearFilter,
                footerFilter: {
                    filterKey: '',
                    filterValue: ''
                }
            }

        case FOOTER_LOC:
            let defaultLoc = {
                city: null,
                country: 'US',
                countyOrParish: null,
                zip: null,
                stateOrProvince: null
            }
            defaultLoc[payload?.filterKey] = payload?.filterValue
            return { ...state, footerFilter: payload, searchbar: payload?.filterValue,locationParams:defaultLoc }

        default:
            return state
    }
}

export default filterReducer